import { EmbedConfig } from '@cpd-app/generated';
import { createAction, props } from '@ngrx/store';

export const getEmbedConfig = createAction('[PowerBI] get embed config');

export const getEmbedConfigSuccess = createAction(
  '[PowerBI] get embed config success',
  props<{ embedConfig: EmbedConfig }>()
);

export const getEmbedConfigFailure = createAction(
  '[PowerBI] get embed config failure',
  props<{ error: any }>()
);
